export default __webpack_public_path__ + "static/media/Polygon.23e5b180.svg";